import React, {useCallback, useMemo} from 'react';
import {useDropzone} from 'react-dropzone';
import Typography from '@material-ui/core/Typography';
import { Auth, API } from "aws-amplify";

import { useSnackbar } from 'notistack';

function arrayBufferToBase64(buffer) {
  let binary = '';
  let bytes = new Uint8Array(buffer);
  let len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};


export default function FileUpload({
  accept = {'application/gml+xml': ['.GML','.gml']},
  onSuccess,
  onError,
  ...props
}) {
  
async function uploadFileHandler(values) {
  try {
    const response = await uploadFile(values);
    
    if (onSuccess) {
      onSuccess(response, values);
    }
  } catch (error) {
    const errorMessage = error.message || error.messsage || 'Unknown error';
    enqueueSnackbar('Kunne ikke tilføje dokument: '+ errorMessage, {variant: 'error'});
    
    if (onError) {
      onError(error, values);
    }
  }
}

async function uploadFile(values) {
  let init = {
    headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
    body : values
  }
  return await API.post("API", "/DocumentFile", init);
}
  //console.log(props)
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader()

      reader.onabort = () => enqueueSnackbar('Indlæsning af fil afbrugt',{variant: 'error',})
      reader.onerror = () => enqueueSnackbar('Kunne ikke læse fil',{variant: 'error',})
      reader.onload = () => {
      // Do whatever you want with the file contents, like upload it to AWS

        const binaryStr = reader.result
        //console.log(binaryStr)
        //console.log(reader)
        //console.log(file)
        //console.log(arrayBufferToBase64(binaryStr))

        let body = {
          "extension": file.name.slice(-3),
          "filename": file.name.substring(0, file.name.length-4),
          "data": arrayBufferToBase64(binaryStr)
        }
        //console.log(body)
        uploadFileHandler(body)


      }
      reader.readAsArrayBuffer(file)
    })
    
  }, [])

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone(
    {
      accept,
      onDrop,
      maxFiles: 1
    }
  );

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isDragActive,
    isDragReject
  ]);

  return (
    <div {...getRootProps({style})}>
      <input {...getInputProps()} />
        {isDragAccept && (<Typography>Understøtter {accept.join(', ')}</Typography>)}
        {isDragReject && (<Typography>Ikke den slags</Typography>)}
        {!isDragActive && (<Typography>Træk en fil hertil, eller klik for at vælge</Typography>)}
    </div>
  )
}